import { useApi } from "../../api/APIContext";
import type { Company, Project } from "../../api/dto";
import type { QuestionSet } from "../../api/dto/QuestionSet";
import type { EnrichedInspection } from "./types";

export const useEnrichedInspection = (
  inspectionId: string | undefined,
): EnrichedInspection | null => {
  const { inspections, projects, companies, questionSets, assessors, loading, refresh } = useApi();
  if (!inspectionId) {
    return null;
  }
  const projectsMap = projects.reduce(
    (map, project) => {
      map[project.id] = project;
      return map;
    },
    {} as { [key: string]: Project },
  );
  const companiesMap = companies.reduce(
    (map, company) => {
      map[company.id] = company;
      return map;
    },
    {} as { [key: string]: Company },
  );
  const questionSetsMap = questionSets.reduce(
    (map, questionSet) => {
      map[questionSet.id] = questionSet;
      return map;
    },
    {} as { [key: string]: QuestionSet },
  );
  const inspection = inspections.find((inspection) => inspection.id === inspectionId);
  if (!inspection) return null;
  const project = projectsMap[inspection.projectId];
  const company = companiesMap[project?.companyId ?? ""];
  const questionSet = questionSetsMap[inspection.questionSetId];
  return {
    ...inspection,
    projectName: project?.name ?? "Onbekend project",
    project,
    companyName: company?.name ?? "Onbekend bedrijf",
    company,
    questionSetName: questionSet?.name ?? "Onbekende vragenlijst",
    questionSet,
  };
};
